import { render, staticRenderFns } from "./InvestorsListPage.vue?vue&type=template&id=202f7d3e&scoped=true&"
import script from "./InvestorsListPage.vue?vue&type=script&lang=js&"
export * from "./InvestorsListPage.vue?vue&type=script&lang=js&"
import style0 from "./InvestorsListPage.vue?vue&type=style&index=0&id=202f7d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f7d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VFlex,VLayout,VPagination,VSelect,VTextField})
